import React, {useEffect, useState} from 'react';
import {Route, Routes} from "react-router-dom";
import Overview from "./overview-seller";
import BusinessCommissions from "./overview-seller/businessCommissions";
import WeighingStation from "./weighing-station/weighingStation";
import Customer from "./customer/customer";
import OverviewWeighingStation from "./overview-weighing-station";
import Account from "./account";
import SubscriptionPackage from "./overview-weighing-station/subscriptionPackage";
import NotFound from "../../custom/notFound/notFound";
import WeighingSlip from "./weighing-slip";
import Report from "./report";
import IndexMobile from "../canMobile/weighing-slip/indexMobile";
import AccountMobile from "../canMobile/account";

const CanRouter = () => {

    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;

    return (
        <Routes path={"/"}>
            <Route path="overview-seller" element={<Overview/>}/>
            <Route path="weighing-station" element={<WeighingStation/>}/>
            <Route path="customer" element={<Customer/>}/>
            <Route path="business-commissions" element={<BusinessCommissions/>}/>
            <Route path="overview-weighing-station" element={<OverviewWeighingStation/>}/>
            <Route path="account" element={!isMobile ? <Account/> : <AccountMobile/>}/>
            <Route path="report" element={<Report/>}/>
            <Route path="subscription-package" element={<SubscriptionPackage/>}/>
            <Route path="report-weighing-station/:code" element={!isMobile ? <WeighingSlip/> : <IndexMobile/>}/>
            {/*<Route path="weighing-slip/:code/add" element={<AddWeighingSlip/>}/>*/}
            <Route path="/:somestring" element={<NotFound/>}/>
        </Routes>
    );
};

CanRouter.propTypes = {};

export default CanRouter;
